import axiosInstance from "src/config/axiosInstance";

export const ConvertImageToBase64 = async (imageUrl, forceToPng = false) => {
    try {
        const directConversion = await new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.src = imageUrl + "?not-from-cache-please";

            img.onload = () => {
                try {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    canvas.width = img.width;
                    canvas.height = img.height;

                    ctx.drawImage(img, 0, 0);

                    const dataUrl = canvas.toDataURL(
                        forceToPng ? "image/png" : "image/png",
                    );
                    resolve(dataUrl);
                } catch (canvasError) {
                    reject(canvasError);
                }
            };

            img.onerror = (error) => reject(error);
        });

        return directConversion;
    } catch (directError) {
        console.warn(
            "Direct image conversion failed, trying API fallback:",
            directError,
        );

        try {
            const response = await axiosInstance.get("/utils/image", {
                params: {
                    url: imageUrl,
                    forcePng: forceToPng,
                },
                headers: {
                    "tz-api-key": process.env.REACT_APP_TZ_API_KEY || "",
                },
                timeout: 10000,
            });

            if (response.data) {
                return response.data.url;
            } else {
                throw new Error("API response is empty");
            }
        } catch (apiError) {
            console.error("API fallback also failed:", apiError);
            throw new Error(
                `Both direct conversion and API fallback failed. Direct error: ${directError.message}, API error: ${apiError.message}`,
            );
        }
    }
};
